import DeptService from "../DeptService";
import FileService from "../FileService";
import BaseClassicService from "@/core/source/BaseClassicService";
import UserService from "@/core/source/UserService";

export default {
    state: {
        services: {
            'BaseService': BaseClassicService,
            'UserService': UserService,
            //
            'DeptService': DeptService,
            'FileService': FileService,
            'BaseClassicService': BaseClassicService

        }
    },
    getters: {
        nameToService: (state) => (classNameService, param1, param2, param3, param4, param5) => {
            for (const item in state.services) {
                if (item === classNameService) {
                    return new state.services[item](param1, param2, param3, param4, param5)
                }
            }
            console.error(`${classNameService} not found`);
        },

    }

}